<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tìm kiếm">
          <div slot="content">
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Tên doanh nghiệp</label>
              <input type="text" class="form-control" v-model="filterData.name" placeholder="Nhập tên doanh nghiệp..."/>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Ngành hàng</label>
              <input type="text" class="form-control" v-model="filterData.type" placeholder="Nhập ngành hàng ..."/>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>Chủ doanh nghiệp</label>
              <input type="text" class="form-control" v-model="filterData.owner"
                     placeholder="Nhập chủ doanh nghiệp ..."/>
            </div>
            <div class="form-group col-md-3 col-sm-6 col-xs-12">
              <label>SĐT Doanh nghiệp</label>
              <input type="text" class="form-control" v-model="filterData.phone"
                     placeholder="Nhập SĐT Doanh nghiệp ..."/>
            </div>
          </div>
          <div slot="footer">
            <div class="d-flex justify-content-between align-items-center">
              <b-button variant="success" @click="add"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                Thêm mới
              </b-button>
              <b-button variant="warning" @click="search"><span class="glyphicon glyphicon-search"
                                                                aria-hidden="true"></span>Tìm kiếm
              </b-button>
            </div>
          </div>
        </va-box>
      </div>

      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Danh sách doanh nghiệp">
          <div slot="content">
            <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
              </template>
              <template v-slot:cell(id)="data">
                {{genSeqId(data)}}
              </template>

              <template v-slot:cell(enable_phone_number_management)="data">
                <div class="form-group col-md-12 col-sm-12 col-xs-12">
                  <b-form-checkbox v-model="data.item.enable_phone_number_management" switch disabled size="lg"></b-form-checkbox>
                </div>
              </template>

              <template v-slot:cell(actions)="dataId">
                <b-button variant="warning" v-b-tooltip.hover title="Cập nhật" @click="edit(dataId.item.id)"><i
                  class="fa fa-edit"/></b-button>
                <b-button variant="success" v-b-tooltip.hover title="Cấu hình tổng đài" @click="showCallCenterConfig(dataId.item)">
                  <img class="fa-icon" src="../../../assets/icon/phone-settings.png" alt="logo">
                </b-button>
                <b-button variant="danger" v-b-tooltip.hover title="Xoá"
                          @click="remove(dataId.item.id, dataId.item.name)"><i class="fa fa-trash"/></b-button>
              </template>

            </b-table>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>

      <b-modal size='xl' id="callCenterConfig" hide-footer title="Cấu hình tổng đài">
        <CallCenterConfig :company="currentCompany" :hideModal="hideCallCenterModal"></CallCenterConfig>
      </b-modal>
    </section>
  </div>

</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import CompanyAPI from '../../../api/company'
import Utils from '../../../common/utils'
import CallCenterConfig from '../../../components/CallCenterConfig'
import {CALL_CENTER_CONFIG} from '../../../common/constant'
import callCenterApi from '../../../api/callCenter'

export default {
  name: 'CompanyList',
  components: {
    CallCenterConfig,
    'va-box': VABox
  },
  data () {
    return {
      filterData: {
        name: '',
        type: '',
        owner: '',
        phone: ''
      },
      items: [],
      currentCompany: null,
      fields: [
        {
          key: 'id',
          label: 'STT'
        },
        {
          key: 'name',
          label: 'Tên doanh nghiệp'
        },
        {
          key: 'enable_phone_number_management',
          label: 'Quản lý số'
        },
        {
          key: 'type',
          label: 'Ngành hàng'
        },
        {
          key: 'owner',
          label: 'Chủ doanh nghiệp'
        },
        {
          key: 'phone',
          label: 'SĐT doanh nghiệp'
        },
        {
          key: 'actions',
          label: 'Tuỳ chọn',
          thStyle: 'width: 15%',
          class: 'actions-cell'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      productTypes: CALL_CENTER_CONFIG.PRODUCT_TYPES,
      paymentTypes: CALL_CENTER_CONFIG.PAYMENT_TYPES,
      sipMethods: CALL_CENTER_CONFIG.SIP_METHOD,
      discountTypes: CALL_CENTER_CONFIG.DISCOUNT_TYPES,
    }
  },
  mounted () {
    this.filter()
  },
  methods: {
    updateCallCenterStatus (call_center, company_id) {
      callCenterApi.updateStatus(call_center.is_enable, company_id).then(res => {
        if (res != null && res.data != null) {
          Utils.successToast(this.$bvToast)
        }
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    genSeqId (data) {
      return data.index + (this.currentPage - 1) * this.pageSize + 1
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      CompanyAPI.filter(this.filterData, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    search () {
      this.filter()
    },
    add () {
      this.$router.push('/company/add')
    },
    edit (id) {
      this.$router.push('/company/edit/' + id)
    },
    remove (id, name) {
      if (id) {
        this.$bvModal.msgBoxConfirm('Xóa ' + name + '. Bạn có chắc không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            CompanyAPI.remove(id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    },
    showCallCenterConfig (company) {
      this.currentCompany = company
      this.$bvModal.show('callCenterConfig')
    },
    hideCallCenterModal () {
      this.$bvModal.hide('callCenterConfig')
      this.filter()
      Utils.successToast(this.$bvToast)
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user_management/company/CompanyList.vue